module.exports = __webpack_public_path__ + "files/b725fc83c7d2f9f1771259b9a3d91786.png";